import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export const CREATE_WORKER = gql`
  mutation createWorker(
    $workerInput: CreateWorkerInput!
    $worksUserInput: CreateWorksUserInput!
    $allowLists: [AllowListInput!]!
  ) {
    createWorker(
      workerInput: $workerInput
      worksUserInput: $worksUserInput
      allowLists: $allowLists
    ) {
      worker {
        id
        isInternal
        active
        baseRate
        ftePercentage
        fteFromUkg
        worksUser {
          id
          firstName
          lastName
          lastSignInAt
          timeZoneAbbreviation
        }
        homeUnit {
          id
          name
        }
        allowedUnits {
          id
          name
        }
        role {
          id
          abbreviation
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const UPDATE_WORKER = gql`
  mutation updateWorker(
    $workerId: ID!
    $workerInput: UpdateWorkerInput!
    $worksUserInput: UpdateWorksUserInput!
    $allowLists: [AllowListInput!]!
  ) {
    updateWorker(
      workerId: $workerId
      workerInput: $workerInput
      worksUserInput: $worksUserInput
      allowLists: $allowLists
    ) {
      worker {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const createWorkerAction = function (form) {
  return {
    onCompleted(response) {
      if (response && response.createWorker.errors) {
        addErrorsToForm(form, response.createWorker.errors);
      }
    },
    refetchQueries: ['PaginatedWorkersQuery'],
    onError: (error) => {
      console.warn('onError', error);
      createMessage(
        'error',
        'Failed to create Worker Details. Please try again or contact your hiring partner.'
      );
    },
  };
};

export const updateWorkerAction = function (form) {
  return {
    onCompleted(response) {
      if (response && response.updateWorker.errors) {
        addErrorsToForm(form, response.updateWorker.errors);
      }
    },
    refetchQueries: ['WorkerDetail'],
    onError: (error) => {
      console.warn('onError', error);
      createMessage(
        'error',
        'Failed to update Worker Details. Please try again or contact your hiring partner.'
      );
    },
  };
};

export const formatAllowListsToAllowedUnits = (homeUnitId, allowLists) => {
  const allowListsByUnit = groupAllowListsByUnit(allowLists);
  const allowedRolesByUnit = [];

  Object.keys(allowListsByUnit).forEach((unitId) => {
    const allowListGroup = allowListsByUnit[unitId];

    allowedRolesByUnit.push({
      unit: unitId,
      roles: allowListGroup.map((allowList) => allowList.role.id),
      isHomeUnit: unitId === homeUnitId,
    });
  });

  return allowedRolesByUnit;
};

export const expandAllowedUnitsToAllowLists = (allowedUnits) => {
  const allowLists = [];

  allowedUnits.forEach((allowedUnit) => {
    allowedUnit.roles.forEach((role) => {
      allowLists.push({
        organizationUnitId: allowedUnit.unit,
        roleId: role,
      });
    });
  });

  return allowLists;
};

export const getSelectedHomeUnit = (allowedUnits) => {
  const homeUnit = allowedUnits.find((unit) => unit.isHomeUnit);
  return homeUnit?.unit;
};

const groupAllowListsByUnit = (allowLists) => {
  const allowListsByUnit = new Map();

  allowLists.forEach((allowList) => {
    const unitId = allowList.organizationUnit.id;

    if (!allowListsByUnit[unitId]) {
      allowListsByUnit[unitId] = [];
    }

    allowListsByUnit[unitId].push(allowList);
  });

  return allowListsByUnit;
};
